import { z } from 'zod'
import { oc } from '@orpc/contract'

export const acceptOrganizationConnect = oc
  .route({ method: 'POST', path: '/v2/organizations/connects/{id}/accept' })
  .input(z.object({ id: z.string() }))
  .output(
    z.object({
      id: z.string(),
      status: z.literal('accepted'),
      initiator: z.object({ id: z.string(), name: z.string() }),
      recipient: z.object({ id: z.string(), name: z.string() }),
    }),
  )
